import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from 'src/environments/environment';
import {AsgardFeatureNames} from 'src/models/AsgardFeatures';
import {MarkersBarService} from 'src/app/services/markers-bar.service';
import {Subscription} from 'rxjs';
import {DocumentMarkersMode} from 'src/app/core/pdf-utils/enums';
import {IMarkerColor} from 'src/app/core/interfaces';
import {DocumentManagerService} from 'src/app/services/document/document-manager.service';
//import {ModalWindowService} from 'src/app/services/ui/modal-window.service';
import {ExtractionOptionsDialogComponent} from '../../dialogs/extraction-options-dialog/extraction-options-dialog.component';
import { FloatingMenuComponent } from '../../floating-menu/floating-menu.component';
import { MatDialog } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { TooltipDirective } from '../../../utils/directives/tooltip.directive';

@Component({
    selector: 'asg-highlighter-floating-menu',
    templateUrl: './highlighter-floating-menu.component.html',
    styleUrls: ['./highlighter-floating-menu.component.scss'],
    standalone: true,
    imports: [FloatingMenuComponent, TooltipDirective, NgClass]
})
export class HighlighterFloatingMenuComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();
  @ViewChild(FloatingMenuComponent) floatingMenu: FloatingMenuComponent;

  supportedColors: IMarkerColor[] = environment.highlight.supportedColors as IMarkerColor[];
  AsgardFeatureNames: typeof AsgardFeatureNames = AsgardFeatureNames;
  DocumentMarkersMode: typeof DocumentMarkersMode = DocumentMarkersMode;
  activeColor: IMarkerColor;
  modeActive: DocumentMarkersMode;

  constructor(private readonly markersBarService: MarkersBarService,
              private readonly docMgrService: DocumentManagerService,
              //private modalService: ModalWindowService,
              private readonly dialog: MatDialog ) {}

  ngOnInit(): void {
    this.initSubscriptions();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private initSubscriptions(): void {
    this.subscriptions.add(
      this.markersBarService.getActiveModeSub().subscribe(mode => {
        this.modeActive = mode;
      })
    );

    this.subscriptions.add(
      this.markersBarService.getActiveColorSub().subscribe(color => {
        this.activeColor = color;
      })
    );
    this.subscriptions.add(
      this.docMgrService.documentReady.subscribe(() => {
        this.resetState();
      })
    );
  }

  colorChosen(color: IMarkerColor): void {
    setTimeout(() => this.markersBarService.toggleColor(color), 50);
  }

  eraserClicked(): void {
    setTimeout(() => this.markersBarService.toggleEraser(), 50);
  }

  async extract(): Promise<void> {
    let result = await this.dialog.open(ExtractionOptionsDialogComponent).afterClosed().toPromise();
    this.markersBarService.extractMarkers(result.withColor, result.withFormatting, result.sortByColor);
  }

  close(): void {
    this.floatingMenu.close();
    this.floatingMenu.hide();
  }

  private resetState(): void {
    this.markersBarService.resetState();
  }
}
